import metaLogo from "@/assets/logos/meta.webp";
import zapierLogo from "@/assets/logos/zapier.webp";
import openaiLogo from "@/assets/logos/openai.webp";
import highlevelLogo from "@/assets/logos/highlevel.webp";

const logos = [
  { src: metaLogo, alt: "Meta" },
  { src: zapierLogo, alt: "Zapier" },
  { src: openaiLogo, alt: "OpenAI" },
  { src: highlevelLogo, alt: "HighLevel" },
];

export const LogoCarousel = () => {
  // Double the logos for seamless infinite scroll
  const duplicatedLogos = [...logos, ...logos, ...logos, ...logos];

  return (
    <div className="w-full overflow-hidden">
      <p className="text-sm text-muted-foreground mb-6 text-center">
        Proficient with leading platforms
      </p>
      <div className="relative">
        {/* Gradient masks */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-background to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-background to-transparent z-10" />
        
        {/* Scrolling container */}
        <div className="flex animate-scroll">
          {duplicatedLogos.map((logo, index) => (
            <div
              key={`${logo.alt}-${index}`}
              className="flex-shrink-0 mx-8 flex items-center justify-center"
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="h-8 w-auto opacity-70 hover:opacity-100 transition-opacity"
                width={120}
                height={32}
                loading="lazy"
                decoding="async"
                fetchPriority="low"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
